// @flow

import React from 'react';
import type { Props } from './types';
import Heading from './configHeading.styled';

export default ({ children }: Props) => (
  <Heading>{children}</Heading>
);
